module.exports = __webpack_public_path__ + "static/img/FLORENCE_PAINT.d702ee6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/FLORENCE_PAINT.jpg
// module id = hBMp
// module chunks = 0